import { render } from "./DownloadCenter.vue?vue&type=template&id=502433eb&scoped=true"
import script from "./DownloadCenter.vue?vue&type=script&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&lang=js"

import "./DownloadCenter.vue?vue&type=style&index=0&id=502433eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502433eb"]])

export default __exports__